export const FILTER_QUERYSTRING_KEYS = ['min_price', 'max_price', 'status'];

// TODO: if backend normalized, they could send `default`s too,
// this could be dynamic and not hard-coded
export const SHOP_FILTER_DEFAULTS = {
  filter_price_range: 'Any price',
  filter_adoptable_status: 'all',
};
